<template>
  <div class="systemsettings-wrap">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">设备离线告警</span>
          <!-- <el-button type="success" plain @click="cancel" style="float: right; padding: 3px 0">返回</el-button> -->
        </div>
        <div class>
            <el-form-item label="设备离线告警" prop="alarmReason">
            </el-form-item>
            <el-form-item label="离线时长">
                <el-row >
                    <el-col :span="12">
                    <el-row>
                        <el-col :span="12">
                            <el-input
                                v-model="form.offlineTime"
                                placeholder=""
                                @input="change($event,item,index)"
                            >
                            </el-input>
                        </el-col>
                        <el-col :span="8">
                            <div style="margin-left: 10px">分钟</div>
                        </el-col>
                    </el-row>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="form.alarmNotice" label="是否告警"></el-checkbox>
                        <el-checkbox v-model="form.smsNotice" label="告警短信"></el-checkbox>
                    </el-col>
                </el-row>
            </el-form-item>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">大屏标题</span>
        </div>
        <div class>
            <el-form-item label="大屏标题" prop="title" style="width:400px">
              <el-input v-model="form.title" placeholder="请输入大屏标题"></el-input>
            </el-form-item>
        </div>
        <div>
          <el-form-item label="logo" prop="logo" style="width:400px">
            <el-upload
              ref="upload"
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-change="handleFileUploaderChange"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <!-- <img v-if="imageUrl" class="avatar" :src="imgBase64Array[0]" alt=""/> -->
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <!-- <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
              </el-upload>
            </el-form-item>
        </div>
      </el-card>
    </el-form>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
    <el-button @click="cancel" class="resetbtn">取消</el-button>
    <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from "@/utils/host";
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      form: {
          offlineTime: "",
          smsNotice:false,
          alarmNotice: false,
          title:'',
          logo:'',
      },
      rules: {
      },
      currentSettings: {},
      imageUrl:'',
      file:[],
      imgBase64Array:[]
    };
  },
  computed: {

  },
  methods: {
    cancel() {
        this.form = {
          offlineTime: this.currentSettings.offlineTime,
          smsNotice: this.currentSettings.smsNotice=="0" ? false : true,
          alarmNotice: this.currentSettings.alarmNotice=="0" ? false : true,
          title:this.currentSettings.title,
          logo:this.currentSettings.logo
        }
        his.imageUrl = this.currentSettings.logo
    },
    save() {
        let data =  {
          offlineTime: this.form.offlineTime,
          smsNotice: this.form.smsNotice ? "1" : "0",
          alarmNotice: this.form.alarmNotice ? "1" : "0",
          title:this.form.title,
          logo:this.imgBase64Array[this.imgBase64Array.length-1]
        }
        console.log(111,data)
        this.$store.dispatch("form/handle", {
            url: "/battery/offline/setting",
            data: data,
            method: "post",
            callback: resp => {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success"
                });
                this.imgBase64Array = []
                this.getData()
            }
        });
    },
    getData(){
      this.$store.dispatch("form/handle", {
        url: "/battery/offline/query",
        data: {},
        method: "get",
        callback: resp => {
            console.log("resp",resp)
            this.currentSettings = resp;
            this.form = {
              offlineTime: this.currentSettings.offlineTime,
              smsNotice: this.currentSettings.smsNotice=="0" ? false : true,
              alarmNotice: this.currentSettings.alarmNotice=="0" ? false : true,
              title:this.currentSettings.title,
              logo:this.currentSettings.logo
            }
            this.imgBase64Array[this.imgBase64Array.length-1] = this.currentSettings.logo
            this.imageUrl = this.currentSettings.logo
        }
      });
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.form.logo = res.data.fileName;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 <= 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/JEPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if(isLt2M && isJPG){
        this.file.push(file)
      }
      return isJPG && isLt2M;
    },
    handleFileUploaderChange(file){
      const self = this
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload  = function(event){
        let img_base64 = this.result
        // console.log(img_base64,'4343img')
        self.imgBase64Array.push(img_base64)
      }
      this.imageUrl = this.imgBase64Array[this.imgBase64Array.length-1]
      console.log(2222,this.imgBase64Array,98888,this.imageUrl)
  },
  },
  mounted() {
  },
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.getData()
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
.systemsettings-wrap /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color:#000000;
}
.systemsettings-wrap /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8a8686;
  border-color: #8a8686;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
#container {
  width: 500px;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/systemSettings/systemSettings.vue